import React, {useState} from "react";
import {Button} from "antd";
import {getCustomerAsSelect} from "../../services/serviceCustomer";
import EmployeeCustomerMatch from "./EmployeeCustomerMatch";

const EmployeeCustomer = ({employeeId}) => {
    const [customers, setCustomers] = useState([])
    const [showModal, setShowModal] = useState(false)

    const handleMatchClick = () => {
        getCustomerAsSelect()
            .then(({data}) => {
                if(data) {
                    setCustomers(data.map(i => ({label: i.label, value: i.key, key: i.key})));
                    setShowModal(!showModal);
                }
            })
    };

    const closeModal = () => {
        setShowModal(!showModal);
    };

    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleMatchClick}
            >
                Müşteri Eşleştir
            </Button>
            {
                showModal ?
                <EmployeeCustomerMatch
                    show={showModal}
                    employeeId={employeeId}
                    modalCloser={closeModal}
                    customers={customers}
                /> : null
            }
        </React.Fragment>
    )
}
export default EmployeeCustomer